export default class DuplicateSystemEventRegisteredError extends Error {}
